import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import MostReadItem, { MostReadContainer }
from '@fuww/library/src/List/MostRead';
import HiddenLoader from '@fuww/library/src/HiddenLoader';
import withQuery from '../../../lib/withQuery';
import MostReadList from './MostReadList';
import articlesQuery from '../../../lib/queries/news/articlesQuery.graphql';
import { newsListImageConfigurations }
from '../../../lib/imageConfigurations';
import mainCategoryIds from '../../../lib/mainCategoryIds';
import { useSiteContext } from '../../SiteContext';
import messages from '../../../lib/messages.json';

const MostRead = ({
  data,
  noBorderFirstItem,
  showLoader,
}) => {
  const articles = data.universalNewsArticles;
  const intl = useIntl();

  if (showLoader) {
    return (
      <MostReadContainer
        title={intl.formatMessage(messages.mostRead)}
      >
        {Array.from({ length: 6 }, (_, index) => index).map((_, index) => (
          <MostReadItem
            // eslint-disable-next-line react/no-array-index-key
            key={`skeleton-${index}`}
            showLoader
            number={index + 1}
            title=""
          />
        ))}
      </MostReadContainer>
    );
  }

  return articles.length > 0 && (
  <MostReadContainer
    title={intl.formatMessage(messages.mostRead)}
  >
    <MostReadList
      showLoader={showLoader}
      newsArticles={articles}
      noBorderFirstItem={noBorderFirstItem}
      showImage
      showCategory
    />
  </MostReadContainer>
  );
};

MostRead.propTypes = {
  data: PropTypes.shape({
    universalNewsArticles: PropTypes.arrayOf(PropTypes.shape({})),
  }),
  noBorderFirstItem: PropTypes.bool,
  showLoader: PropTypes.bool,
};

MostRead.defaultProps = {
  data: {},
  noBorderFirstItem: null,
  showLoader: false,
};

const MostReadWithQuery = withQuery(MostRead, { renderAlways: true });

const errorMessage = 'Error while loading news articles...';

const MostReadWithData = ({
  noBorderFirstItem,
}) => {
  const { newsboard } = useSiteContext();

  const variables = {
    newsboard,
    withoutDescriptionAndCreator: true,
    withoutSummaryAndLabel: true,
    categoryIds: mainCategoryIds,
    imageConfigurations: newsListImageConfigurations,
    inDays: 5,
    limit: 6,
    sort: 'POPULARITY',
  };

  return (
    <MostReadWithQuery
      query={articlesQuery}
      variables={variables}
      errorMessage={errorMessage}
      noBorderFirstItem={noBorderFirstItem}
      loader={<HiddenLoader />}
    />
  );
};

MostReadWithData.propTypes = {
  noBorderFirstItem: PropTypes.bool,
};

MostReadWithData.defaultProps = {
  noBorderFirstItem: null,
};

export default MostReadWithData;
